<template>
  <div class="context">
    <div class="header">
      <div class="btn_box">
        <div class="btn nomal_btn" @click="goBack">
          <i class="el-icon-back"></i>
          返回
        </div>
      </div>
      <div class="title">{{ viewTitle }}</div>
    </div>

    <div class="main_box">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="药师名字" prop="name">
          <el-input
            class="width_220"
            placeholder="请输入药师名字"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            class="width_220"
            placeholder="请输入药师手机号"
            v-model="form.phone"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职称" prop="title">
          <el-input
            class="width_220"
            placeholder="请输入职称"
            v-model="form.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="药店名称" prop="pharmacy_name">
          <el-autocomplete
            class="width_300"
            v-model="form.pharmacy_name"
            clearable
            @clear="clear"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            value-key="name"
            :debounce="1000"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <!-- <el-form-item label="地址" prop="address">
          <el-input
            class="width_220"
            placeholder="请输入地址"
            v-model="form.address"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="viewTitle === '添加药师'"
            type="primary"
            @click="submitAdd"
            >提交</el-button
          >
          <el-button v-else type="primary" @click="submitEdit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { clone } from "@/global/utils";
export default {
  name: "addView",
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号！"));
      }
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号！"));
      }
    };
    return {
      viewTitle: "添加药师",
      form: {
        name: "",
        phone: "",
        sex: 1,
        title: "",
        hospital_id: "",
        pharmacy_name: ""
        // address: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名字！", trigger: "blur" }],
        // address: [{ required: true, message: "请输入地址！", trigger: "blur" }],
        pharmacy_name: [
          { required: true, message: "请选择药店名称！", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别！", trigger: "blur" }],
        title: [{ required: true, message: "请输入职称！", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
      },

      hos_search_input: "",
      hos_search_cascader: [],
      cascader_props: {
        expandTrigger: "hover",
        value: "name",
        label: "name",
        children: "city_list",
      },

      dialogVisible_doc: false,
      tableData: [],
    };
  },
  computed: {
    ...mapState("manageData", ["pharmacist_data"]),
    ...mapState("comInformationData", ["city_list"]),
  },
  mounted() {
    if (this.pharmacist_data) {
      this.viewTitle = "编辑药师- " + this.pharmacist_data.name;
      this.form = clone(this.pharmacist_data);
    } else {
      this.viewTitle = "添加药师";
      this.form = {
        name: "",
        phone: "",
        sex: 1,
        title: "",
        hospital_id: "",
        pharmacy_name: "",
      };
    }
  },
  methods: {
    goBack() {
      this.$emit("changeTopTab", "tableView");
    },
    querySearchAsync(queryString, cb) {
      this.httpGet("/pharmacist/pharmacy", {
        hospital_name: queryString,
      }).then((res) => {
        cb(res.data.data_list);
      });
    },
    handleSelect(item) {
        this.form.hospital_id = item.hospital_id;
    },
    clear() {
        this.form.hospital_id = '';
    },

    submitAdd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
          };
          this.httpPost("/pharmacist/save", params).then((res) => {
            this.$message.success("添加成功！");
            this.goBack();
          });
        }
      });
    },
    submitEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
          };
          this.httpPut(`/pharmacist/${this.form.user_id}`, params).then(res => {
            this.$message.success("更新成功！");
            this.goBack()
          })
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
$view_background: rgb(246, 247, 248);
$btn_border: rgb(246, 247, 248);
.context {
  width: 100%;
  height: 100%;
  background: $view_background;
  .header {
    width: 100%;
    line-height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid #ddd;
    .title {
    }
    .btn_box {
      padding-right: 20px;
      .btn {
        margin-top: 10px;
        border: 1px solid $btn_border;
      }
    }
  }

  .main_box {
    padding: 10px;

    .hos_select_box {
      width: 350px;
      border: 1px solid #dcdfe6;
      height: 40px;
      line-height: 40px;
      box-sizing: border-box;
      border-radius: 4px;
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      color: #606266;
      span,
      i {
        align-self: center;
      }
    }
  }
}
.table_box {
  height: 100%;
  box-sizing: border-box;
  .table_search {
    padding: 3px 15px;
    background: #fff;
    display: flex;
    div {
      padding-bottom: 5px;
    }
    .two {
      padding-left: 5px;
    }
  }
  .table {
  }
}
</style>